import PropTypes from "prop-types"
import { useContext, useEffect } from "react"
import admin from "~/assets/Icons/admin.svg"
import coloredAdmin from "~/assets/Icons/colored-admin.svg"
import analyticsColor from "~/assets/Icons/colored-pie-chart.svg"
import coloredUser from "~/assets/Icons/colored-user.svg"
import analytics from "~/assets/Icons/feather-pie-chart.svg"
import user from "~/assets/Icons/user.svg"
import ContentTabs from "~/components/Common/ContentTabs"
import AppContext from "~/contexts/App"
import { UsersContainer } from "~/contexts/Users"
import CreateAnalyticsUser from "~/dialogs/CreateAnalyticsUser"
import Page from "~/pages/Page"
import Router from "~/router"

import usePermissionsRedirect from "~/hooks/usePermissionsRedirect"
import useStyles from "./styles"

const User = ({ routes = [], ...rest }) => {
  const classes = useStyles()
  const { authUser } = useContext(AppContext)
  const isSuper = authUser?.permission_group === "super"

  const { setPageTitle } = useContext(AppContext)
  usePermissionsRedirect("/learning-paths", "users")

  //set user page title and subtitle
  useEffect(() => {
    setPageTitle("Users")
  }, [])

  let tabs = [
    {
      label: "Users",
      link: `/users/user-list`,
      icon1: user,
      icon2: coloredUser,
    },
    isSuper && {
      label: "Administrators",
      link: `/users/admin-list`,
      icon1: admin,
      icon2: coloredAdmin,
    },
    // {
    //   label: "Waitlist",
    //   link: `/users/waitlist`,
    //   icon1: analytics,
    //   icon2: analyticsColor,
    // },
    isSuper && {
      label: "Analytics",
      link: `/users/analytics`,
      icon1: analytics,
      icon2: analyticsColor,
    },
    {
      label: "Demo Users",
      link: `/users/demo`,
      // icon1: analytics,
      // icon2: analyticsColor,
    },
  ].filter((x) => x)

  return (
    <Page>
      <UsersContainer>
        <ContentTabs tabs={tabs} />
        <Router routes={routes} {...rest} />
        <CreateAnalyticsUser />
      </UsersContainer>
    </Page>
  )
}

User.propTypes = {
  routes: PropTypes.array,
}

export default User
